import { useEffect, useMemo } from "react";
import { useLocation } from "react-router";

import store from "../../store";

/**
 * Integrate Matomo with useMatomo()
 */
export default function useMatomo() {
  let location = useLocation();

  const _paq = useMemo(() => window._paq || [], []);
  const settings = store.getState().auth?.settings;

  const trackingPermission = useMemo(() => settings?.tracking ?? 1, [settings]);

  useEffect(() => {
    if (location && trackingPermission) {
      _paq.push(["setDocumentTitle", location.pathname]);
      _paq.push(["trackPageView"]);
    }
  }, [_paq, location, trackingPermission]);
}
